var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconXpJp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0853 1.44344L1.44354 11.0852C0.938286 11.5904 0.938286 12.4096 1.44354 12.9148L11.0853 22.5566C11.5905 23.0618 12.4097 23.0618 12.9149 22.5566L22.5567 12.9148C23.0619 12.4096 23.0619 11.5904 22.5567 11.0852L12.9149 1.44344C12.4097 0.938186 11.5905 0.938187 11.0853 1.44344Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3206 4.82176L4.82178 11.3206C4.4467 11.6957 4.4467 12.3038 4.82178 12.6789L11.3206 19.1777C11.6957 19.5528 12.3038 19.5528 12.6789 19.1777L19.1777 12.6789C19.5528 12.3038 19.5528 11.6957 19.1777 11.3206L12.6789 4.82176C12.3038 4.44668 11.6957 4.44668 11.3206 4.82176Z",
    fill: "url(#paint0_linear_2887_35384)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M11.321 1.67914L1.67924 11.3209C1.30416 11.6959 1.30416 12.3041 1.67924 12.6791L11.321 22.3209C11.696 22.6959 12.3042 22.6959 12.6792 22.3209L22.321 12.6791C22.696 12.3041 22.696 11.6959 22.321 11.3209L12.6792 1.67914C12.3042 1.30406 11.696 1.30406 11.321 1.67914Z",
    fill: "url(#paint1_linear_2887_35384)",
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2548 3.34503L16.9474 4.84117L15.9175 5.14055C15.4984 5.23819 15.4874 5.83087 15.9023 5.94409L16.9858 6.26322L17.2514 7.72175C17.3528 8.15106 17.966 8.14536 18.0599 7.71453L18.379 6.23397L19.4177 5.94029C19.8295 5.84303 19.8482 5.26402 19.4435 5.14055L18.36 4.76328L18.0697 3.34085C17.9839 2.88988 17.3369 2.89254 17.2548 3.34427V3.34503Z",
    fill: "url(#paint2_linear_2887_35384)",
    stroke: "#FFBC52",
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64328 15.9163L5.33592 17.4125L4.30595 17.7118C3.88689 17.8095 3.87587 18.4022 4.29075 18.5154L5.37429 18.8345L5.63986 20.293C5.7413 20.7223 6.35449 20.7167 6.44833 20.2858L6.76747 18.8053L7.80618 18.5116C8.21802 18.4143 8.23663 17.8353 7.83202 17.7118L6.74847 17.3346L6.45821 15.9121C6.37235 15.4612 5.72534 15.4638 5.64328 15.9156V15.9163Z",
    fill: "url(#paint3_linear_2887_35384)",
    stroke: "#FFBC52",
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6144 21.021C18.1839 21.021 18.6456 20.5593 18.6456 19.9899C18.6456 19.4204 18.1839 18.9588 17.6144 18.9588C17.045 18.9588 16.5833 19.4204 16.5833 19.9899C16.5833 20.5593 17.045 21.021 17.6144 21.021Z",
    fill: "url(#paint4_linear_2887_35384)",
    stroke: "#FFBC52",
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6466 18.1092C20.0318 18.1092 20.3441 17.7969 20.3441 17.4117C20.3441 17.0265 20.0318 16.7142 19.6466 16.7142C19.2614 16.7142 18.9491 17.0265 18.9491 17.4117C18.9491 17.7969 19.2614 18.1092 19.6466 18.1092Z",
    fill: "url(#paint5_linear_2887_35384)",
    stroke: "#FFBC52",
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.0209C14 11.3273 13.9282 11.6073 13.7846 11.8611C13.6457 12.11 13.4327 12.3111 13.1454 12.4643C12.863 12.6127 12.5159 12.6869 12.1041 12.6869H11.4075V14.396H10V9.33333H12.1041C12.5111 9.33333 12.8558 9.40514 13.1382 9.54876C13.4255 9.69238 13.6409 9.89106 13.7846 10.1448C13.9282 10.3985 14 10.6906 14 11.0209ZM11.9677 11.5666C12.3651 11.5666 12.5637 11.3847 12.5637 11.0209C12.5637 10.6523 12.3651 10.4679 11.9677 10.4679H11.4075V11.5666H11.9677Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57361 4.50951C7.07761 4.50951 7.48619 4.10093 7.48619 3.59693C7.48619 3.09293 7.07761 2.68436 6.57361 2.68436C6.06961 2.68436 5.66104 3.09293 5.66104 3.59693C5.66104 4.10093 6.06961 4.50951 6.57361 4.50951Z",
    fill: "url(#paint6_linear_2887_35384)",
    stroke: "#FFBC52",
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72477 6.45396C5.06573 6.45396 5.34214 6.17755 5.34214 5.83658C5.34214 5.49562 5.06573 5.21921 4.72477 5.21921C4.3838 5.21921 4.10739 5.49562 4.10739 5.83658C4.10739 6.17755 4.3838 6.45396 4.72477 6.45396Z",
    fill: "url(#paint7_linear_2887_35384)",
    stroke: "#FFBC52",
    strokeWidth: 0.0481237,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_35384",
    x1: 6.26837,
    y1: 10.1966,
    x2: 17.9591,
    y2: 12.7689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2887_35384",
    x1: 3.97613,
    y1: 9.47559,
    x2: 20.3432,
    y2: 13.0768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4B5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2887_35384",
    x1: 15.5968,
    y1: 5.52313,
    x2: 19.7372,
    y2: 5.52313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2887_35384",
    x1: 3.98529,
    y1: 18.0944,
    x2: 8.1257,
    y2: 18.0944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2887_35384",
    x1: 16.5833,
    y1: 19.9899,
    x2: 18.6459,
    y2: 19.9899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2887_35384",
    x1: 18.9491,
    y1: 17.4117,
    x2: 20.3441,
    y2: 17.4117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2887_35384",
    x1: 7.48722,
    y1: 3.62005,
    x2: 5.66291,
    y2: 3.57865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2887_35384",
    x1: 5.34325,
    y1: 5.85304,
    x2: 4.10919,
    y2: 5.82504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2887_35384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXpJp);
export default __webpack_public_path__ + "static/media/icon-xp-jp.6fb0511a0b642541e01622adcba99984.svg";
export { ForwardRef as ReactComponent };